import { configureStore } from "@reduxjs/toolkit";
import {userSlice} from './counter';

export default configureStore({
  reducer: {
    user: userSlice.reducer
  }
})
